define('views/blocks/CheckoutPaymentView',['underscore', 'backbone', 'jquery', 'router', 'app', 'SubView',
    'views/blocks/CheckoutPaymentMethodView',
    'views/blocks/CheckoutPaymentModeView'

], function (_, Backbone, $, router, app, SubView,
             CheckoutPaymentMethodView,
             CheckoutPaymentModeView
) {

    var checkoutModel;
    var CheckoutPaymentView = Backbone.View.extend(SubView).extend({
        initialize: function (options) {
            checkoutModel = options.checkout;
            var view = this;
            view.subviews = [];
            view.render();

        },
        render: function () {
            var view = this;
            if(checkoutModel.isV2()){
                view.appendView(CheckoutPaymentModeView,'.checkout-payment-mode',{checkout:checkoutModel});
            }else{
                view.appendView(CheckoutPaymentMethodView,'.checkout-payment-method');
            }
        },

    });

    return CheckoutPaymentView;


})
;
